<template>
    <div class="collection-point-design-container">
        <img src="@/assets/image/app/back_max.png" alt="" style="width: 20px;height: 20px;" @click="goParent">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'变压器列表'">
            <div class="el-card1">
                <div class="el-card_header1">
                    <div
                        style="text-align: left; font-size: 16px; border-left:5px solid #56fcff; color: #fff; padding-left: 10px"
                    >
                        <span class="el-card_header1_span">变压器列表</span>
                    </div>
                </div>

                <div class="tree-container">
                    <me-company-list
                        @handleCompanyItem="handleCompanyItem"
                        :companyList="companyList"
                        :selectedIndex="selectedIndex"
                    ></me-company-list>
                </div>
            </div>
        </me-collapes>
        <div class="right_container" :style="{ width: width }">
            <!-- 列表搜索过滤 -->
            <div class="search-wrap">
                <el-form
                    :label-position="'left'"
                    :model="searchForm"
                    ref="searchForm"
                    class="leader-style-form"
                >
                    <el-row :gutter="20">
                        <el-col :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item label="时间" label-width="40px" prop="name">
                                <el-date-picker
                                    v-model="showDate"
                                    :type="pickType" 
                                    :placeholder="pickTp" 
                                    :format="pickFormat" 
                                    :value-format="pickFormat"
                                    @change="handleFilterList()"
                                    :picker-options="pickerOptions"
                                    style="float:left"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>

                        
                    </el-row>
                </el-form>
            </div>

            <div
                style="text-align: left; font-size: 16px; border-left:5px solid #56fcff; color: #fff; padding-left: 10px;margin-top: 20px"
            >变压器负载率趋势图</div>
            <el-scrollbar style="height: calc(100% - 4rem)">
                <div class="echart-container">
                    <v-chart
                        style="width: 1300px"
                        :auto-resize="true"
                        :options="line"
                        ref="line"
                        theme="ovilia-green"
                    />
                </div>
                <div class="echart-container" v-if="showDay">
                    <v-chart
                        style="width: 1300px"
                        :auto-resize="true"
                        :options="line2"
                        ref="line2"
                        theme="ovilia-green"
                    />
                </div>
                <div class="echart-container" v-if="showHour">
                    <v-chart
                        style="width: 1300px"
                        :auto-resize="true"
                        :options="line3"
                        ref="line3"
                        theme="ovilia-green"
                    />
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import CompanyList from "./components-list/company-list-max";
import * as api from "@/http/api-zmy.js";
import * as api1 from "@/http/api.js";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import Collapes from "@/comon/components/collapse-block.vue";
import utils from "@/utils/utils";
import dayjs from "dayjs";
import { getMaxTransformerById } from "@/http/api.js";
export default {
    components: {
        "me-company-list": CompanyList,
        "me-collapes": Collapes,
    },
    data() {
        return {
            companyList: [],
            selectedIndex: 0,
            selectedPoint: '',
            search_type: '10',
            selectedYear: '',
            title: "",
            loading: false,
            treeSelect: {},
            point_id: "",
            showDate: "",
            pickType: 'year',
            pickTp: '选择年份',
            pickFormat: 'yyyy',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            width: "calc(100% - 300px)",
            xAxis: [
                {
                    type: "category",
                    // data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                    data: this.x_list
                }
            ],
            x_list: [],
            transformer_rate_list: [],
            selectLineMonth: "",
            x_list2: [],
            transformer_rate_list2: [],
            selectLineDay: "",
            x_list3: [],
            transformer_rate_list3: [],
            showDay: false,
            showHour: false,
            nextTimeDisabled: false,
            todayM: "",
        };
    },
    created() {
        
    },
    mounted() {
        const queryData = this.$route.query;
        this.search_date = queryData.search_date;
        this.showDate = this.search_date.slice(0, 4);
        this.selectedPoint = queryData.point_id;
        this.search_type = queryData.search_type;
        
        this.getTransformerList();
        this.nextTimeDisabled = true;
        
        this.getMaxTransformerById(this.showDate, '10');
        const demandLine = this.$refs.line.chart;
        //使点击区域变成pointer
        demandLine.getZr().on("mousemove", function (params) {
            var pointInPixel = [params.offsetX, params.offsetY];
            if (demandLine.containPixel("grid", pointInPixel)) {
                demandLine.getZr().setCursorStyle("pointer");
            }
        });
        //折线图区域点击事件
        demandLine.getZr().on("click", params => {
            var pointInPixel = [params.offsetX, params.offsetY];
            var pointInGrid = demandLine.convertFromPixel("grid", pointInPixel);
            var category = demandLine.getModel().get("xAxis")[0].data[
                pointInGrid[0]
            ];
            if (undefined != category) {
                this.selectLineMonth = category;
                this.showDay = true;
                this.showHour = false;
             
                let year_month = this.showDate + "-" + category;
                this.selectLineMonth = year_month;
                //this.getMonthTransformer(this.selectLineMonth);
                this.getMaxTransformerById(year_month, '20')
                // 点击年的时候  清空日的曲线
                this.x_list3 = [];
                this.transformer_rate_list3 = [];
            }
        });
    },
    methods: {
        handleFilterList() {
            if (this.point_id === "" || this.showDate === "") {
            } else {
                let todayM = new Date(this.todayM).getTime();
                let selectTime = new Date(this.showDate).getTime();
                if (selectTime >= todayM) {
                    this.nextTimeDisabled = true;
                } else {
                    this.nextTimeDisabled = false;
                }
                this.getYearTransformer();
                // 切换年份的时候  清空月份和日期的数据
                this.showDay = false;
                this.x_list2 = [];
                this.transformer_rate_list2 = [];
                this.showHour = false;
                this.x_list3 = [];
                this.transformer_rate_list3 = [];


            }
        },
        /**
         * 公司列表选择
         */
        handleCompanyItem(selectCompany) {
            this.point_id = selectCompany.point_id;
            this.selectedPoint = selectCompany.point_id;
            this.title = selectCompany.doc_name;
            this.selectedIndex = this.companyList.findIndex(
                item => item.point_id === this.selectedPoint
            );
            this.getMaxTransformerById(this.search_date, this.search_type);
            // 切换变压器列表，清空月份和日期的数据
            this.showDay = false;
            this.x_list2 = [];
            this.transformer_rate_list2 = [];
            this.showHour = false;
            this.x_list3 = [];
            this.transformer_rate_list3 = [];
        },
        /**
         * 获取公司列表
         */
        getTransformerList() {
            this.loading = true;
            api.getTransformerList().then(res => {
                this.loading = false;
                if (res && res.error_code === "0") {
                    this.companyList = res.bus_json;
                    this.selectedIndex = this.companyList.findIndex(
                        item => item.point_id === this.selectedPoint
                    );
                    this.point_id = res.bus_json[0].point_id;
                    this.title = res.bus_json[0].doc_name;
                }
            });
        },
        getMaxTransformerById(show_day,search_type) {
            api1.getMaxTransformerById({show_day: show_day, point_id: this.selectedPoint, search_type: search_type}).then(res => {
                if (res && res.error_code === "0") {
                    if ('10' === search_type) {
                        this.x_list = res.bus_json.x_list;
                        this.transformer_rate_list = res.bus_json.dataList;
                    } else if ('20' === search_type) {
                        this.x_list2 = res.bus_json.x_list;
                        this.transformer_rate_list2 = res.bus_json.dataList;

                        const dayDemandLine = this.$refs.line2.chart;
                        //使点击区域变成pointer
                        dayDemandLine.getZr().on("mousemove", function (params) {
                            var pointInPixel = [params.offsetX, params.offsetY];
                            if (
                                dayDemandLine.containPixel("grid", pointInPixel)
                            ) {
                                dayDemandLine.getZr().setCursorStyle("pointer");
                            }
                        });
                        //折线图区域点击事件
                        dayDemandLine.getZr().on("click", params => {
                            var pointInPixel = [params.offsetX, params.offsetY];
                            var pointInGrid = dayDemandLine.convertFromPixel(
                                "grid",
                                pointInPixel
                            );
                            var category = dayDemandLine
                                .getModel()
                                .get("xAxis")[0].data[pointInGrid[0]];
                            if (undefined != category) {
                                this.showHour = true;
                                this.selectLineDay = this.selectLineMonth + '-' + category;
                                this.getMaxTransformerById(this.selectLineDay, '30');
                            }
                        });
                    } else if ('30' === search_type) {
                        this.x_list3 = res.bus_json.x_list;
                        this.transformer_rate_list3 = res.bus_json.dataList;
                    }
                }
            });
        },
        getSysDate() {
            api1.getSysDate().then(res => {
                if (res && res.error_code === "0") {
                    this.showDate = res.bus_json.sysdate3;
                    this.todayM = res.bus_json.sysdate3;
                    //this.getYearTransformer();
                }
            });
        },
        goParent() {
            sessionStorage.setItem("activeTab", JSON.stringify({ name:'MaxTransformerLoad', query:{  search_date: this.search_date, search_type: this.search_type }}));
            this.$router.push({ name:'MaxTransformerLoad', query:{  search_date: this.search_date, search_type: this.search_type } })
        },
        /**
         * 上一日、上一月、上一年点击
         */
        forwardTimeClick() {
            this.nextTimeDisabled = false;
            this.showDate = dayjs(new Date(this.showDate))
                .subtract(1, "months")
                .format("YYYY-MM");
            // 切换变压器列表，清空月份和日期的数据
            this.showDay = false;
            this.x_list2 = [];
            this.transformer_rate_list2 = [];
            this.showHour = false;
            this.x_list3 = [];
            this.transformer_rate_list3 = [];
            this.getYearTransformer();
        },
        /**
         * 下一日、下一月、下一年点击
         */

        nextTimeClick() {
            let todayM = new Date(this.todayM).getTime();
            this.showDate = dayjs(new Date(this.showDate))
                .add(1, "months")
                .format("YYYY-MM");
            let selectTime = new Date(this.showDate).getTime();
            if (selectTime >= todayM) {
                this.nextTimeDisabled = true;
            } else {
                this.nextTimeDisabled = false;
            }
            // 切换变压器列表，清空月份和日期的数据
            this.showDay = false;
            this.x_list2 = [];
            this.transformer_rate_list2 = [];
            this.showHour = false;
            this.x_list3 = [];
            this.transformer_rate_list3 = [];
            this.getYearTransformer();
        },
        getYearTransformer() {
            // const loading = this.$loading({
            //     lock: true,
            //     text: 'Loading',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // });
            api1.getYearTransformer({
                point_id: this.point_id,
                show_day: this.showDate
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.x_list;
                    this.transformer_rate_list =
                        res.bus_json.transformer_rate_list;
                    // loading.close();
                }
            });
        },
        /**
        * @description: 获取月
        */
        getMonthTransformer(month) {
            // const loading = this.$loading({
            //     lock: true,
            //     text: 'Loading',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // });
            api1.getMonthTransformer({
                point_id: this.point_id,
                show_day: `${month}`
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list2 = res.bus_json.x_list;
                    this.transformer_rate_list2 =
                        res.bus_json.transformer_rate_list;
                    // loading.close();

                    const dayDemandLine = this.$refs.line2.chart;
                    //使点击区域变成pointer
                    dayDemandLine.getZr().on("mousemove", function (params) {
                        var pointInPixel = [params.offsetX, params.offsetY];
                        if (
                            dayDemandLine.containPixel("grid", pointInPixel)
                        ) {
                            dayDemandLine.getZr().setCursorStyle("pointer");
                        }
                    });
                    //折线图区域点击事件
                    dayDemandLine.getZr().on("click", params => {
                        var pointInPixel = [params.offsetX, params.offsetY];
                        var pointInGrid = dayDemandLine.convertFromPixel(
                            "grid",
                            pointInPixel
                        );
                        var category = dayDemandLine
                            .getModel()
                            .get("xAxis")[0].data[pointInGrid[0]];
                        if (undefined != category) {
                            this.showHour = true;
                            this.selectLineDay = category;
                            this.getDayTransformer(category);
                        }
                    });
                }
            });
        },
        getDayTransformer(day) {
            // const loading = this.$loading({
            //     lock: true,
            //     text: 'Loading',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // });
            api1.getDayTransformer({
                point_id: this.point_id,
                show_day: `${this.selectLineMonth}-${day}`
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list3 = res.bus_json.x_list;
                    this.transformer_rate_list3 =
                        res.bus_json.transformer_rate_list;

                    // loading.close();
                }
            });
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 320px)" : "calc(100% - 61px)";
        }
    },
    computed: {
        line() {
            const options = {
                title: {
                    // text: '变压器负载率趋势图'
                },
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "15%",
                    top: "10%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: [`变压器负载率`],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        // data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                        data: this.x_list,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位(%)",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: `变压器负载率`,
                        type: "line",
                        data: this.transformer_rate_list,
                        itemStyle: {
                            normal: {
                                color: "#0191e7", //点颜色
                                lineStyle: {
                                    color: "#0191e7" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                        // markLine: {
                        //     data: [{ type: 'average', name: '平均值' }]
                        // }
                    }
                ]
            };
            return options;
        },
        line2() {
            const options = {
                title: {
                    // text: '变压器负载率趋势图'
                },
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "15%",
                    top: "10%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: [`${this.selectLineMonth}月变压器负载率`],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        // data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                        data: this.x_list2,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位(%)",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: `${this.selectLineMonth}月变压器负载率`,
                        type: "line",
                        data: this.transformer_rate_list2,
                        itemStyle: {
                            normal: {
                                color: "#0191e7", //点颜色
                                lineStyle: {
                                    color: "#0191e7" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                        // markLine: {
                        //     data: [{ type: 'average', name: '平均值' }]
                        // }
                    }
                ]
            };
            return options;
        },
        line3() {
            const options = {
                title: {
                    // text: '变压器负载率趋势图'
                },
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "15%",
                    top: "10%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: [`${this.selectLineMonth}-${this.selectLineDay}日变压器负载率`],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        // data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                        data: this.x_list3,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位(%)",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: `${this.selectLineMonth}-${this.selectLineDay}日变压器负载率`,
                        type: "line",
                        data: this.transformer_rate_list3,
                        itemStyle: {
                            normal: {
                                color: "#0191e7", //点颜色
                                lineStyle: {
                                    color: "#0191e7" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                        // markLine: {
                        //     data: [{ type: 'average', name: '平均值' }]
                        // }
                    }
                ]
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
.collection-point-design-container {
    width: 100%;
    height: 100%;
    padding: 0 px2Rem(20px);
    box-sizing: border-box;
    display: flex;
    flex-direction: row;

    .el-card1 {
        width: px2Rem(280px);
        height: 100%;
        // border: 1px solid #ebeef5;
        // background-color: #fff;
        color: #fff;
        transition: 500ms;
        border-radius: 4px;
        overflow: hidden;
        box-sizing: border-box;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        .el-card_header1 {
            padding: px2Rem(18px) px2Rem(20px);
            border-bottom: 1px solid #ebeef5;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            .el-card_header1_span {
                color: #fff;
            }
        }

        .tree-container {
            width: 100%;
            height: 90%;
            overflow: hidden;
            padding: px2Rem(10px);
            box-sizing: border-box;
        }
    }
}
// .company-list-container {
//     width: px2Rem(380px);
// }
.echart-container {
    width: 100%;
    margin-top: px2Rem(20px);

    .echarts {
        width: 100% !important;
        height: px2Rem(350px);
    }
}
.search-btn-wrap {
    text-align: right;
}
.search-wrap {
    width: 100%;
    margin-right: px2Rem(20px);
}
.tableTitle {
    position: relative;
    margin: 0 auto;
    width: 100%;
    height: 1px;
    background-color: #d4d4d4;
    text-align: center;
    font-size: px2Rem(16px);
    color: rgba(101, 101, 101, 1);
}
.midText {
    position: absolute;
    left: 50%;
    background-color: #ffffff;
    padding: 0 px2Rem(15px);
    transform: translateX(-50%) translateY(-50%);
}
.right_container {
    transition: width 500ms;
    margin-top: px2Rem(5px);
}
.echart-container .echarts{height: 20.5rem;}
</style>
